import React from "react";

const Servicecard = (props) => {
  return (
    <div className="service-card">
      <div className="service-card-head">
        <h3>{props.servTitle}</h3>
      </div>
      <div className="service-card-image">
        <img src={props.servImage} alt={props.servTitle} />
      </div>
      <div className="service-card-cta">
        <a
          href={props.servLink}
          className="button card-cta boldTitle"
          target="_blank"
          rel="noopener noreferrer"
        >
          Book Now!
        </a>
      </div>
    </div>
  );
};

export default Servicecard;
